




































// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { ItemPanier } from '@/models/alo/ItemPanier'
import { Component, Vue, Watch } from 'vue-property-decorator'
import ProduitQuantfiable from './ProduitQuantfiable.vue'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ProduitMultiples',  
  props: {    
    forceQuantifiable:{
      type:Boolean,
      default:false
    }
  }
})
export default class ProduitMultiples extends mixins(BasePlat) {  
  forceQuantifiable!:boolean

  
  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }

  get platsDic(){
    return this.$store.myGetters.platsDic
  }

  get prixTotal() {           
    return this.plat.selected && this.$refs.quantifiables?(this.$refs.quantifiables as Array<ProduitQuantfiable>)?.reduce((total,cp) => total + cp.itemPanier.prixTotalAvecOptions,0):0
  }

  get qtyTotal(){    
    return this.plat.selected && this.$refs.quantifiables?(this.$refs.quantifiables as Array<ProduitQuantfiable>)?.reduce((total,cp) => total + cp.itemPanier.qty,0):0
  }

  addItemToPanier(){    
    if(!this.canAdd)  this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else {
      (this.$refs.quantifiables as Array<ProduitQuantfiable>)?.forEach(cp => cp.addItemToPanier())
      this.selectProduct(false)     
    }
  }
 
  selectProduct(selected:boolean) {
    this.$store.myActions.ROOM_SERVICES_PLAT_SET_SELECTION({selected,ids:[this.plat.id]})
  }

  togglePlat() {     
    this.selectProduct(!this.plat.selected) 
  }
  
}
